import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/ct'
// const secureResource = hubbleAPI + 'secure/public/ct'
export default ($axios) => ({
  addNumberInfo (cartID, numberInfoDTO, cartItemGroupUpdate) {
    return $axios.post(`${resource}/add-number-info/${cartID}/${cartItemGroupUpdate.groupID}/${cartItemGroupUpdate.sku}`,
      numberInfoDTO)
  },
  removeNumberInfo (cartItemGroupUpdate) {
    return $axios.delete(`${resource}/remove-number-info`, {
      data: {
        ...cartItemGroupUpdate
      }
    })
  },
  removeInstallments(payload) {
    return $axios.delete(`${resource}/remove-installment`, {
      data: {
        ...payload
      }
    })
  },
  addPermissionInformation(permissionDTO, cartID, groupID, sku) {
    return $axios.post(`${resource}/add-permission-info/${cartID}/${groupID}/${sku}`, permissionDTO)
  },
  validateMobileNumber(mobileNumber) {
    return $axios.get(hubbleAPI + `public/ct/validate/mobilenumber/${mobileNumber}`)
  },
  validateIcc(cps, icc) {
    return $axios.get(hubbleAPI + `public/ct/npimport/icc/validate/${cps}/${icc}`)
  },
  addCustomerChangeSubscriptionInfo(payload) {
    return $axios.post(hubbleAPI + '/secure/public/ct/add-change-subscription-info', payload)
  },
  removeCustomerChangeSubscriptionInfo(payload) {
    return $axios.delete(hubbleAPI + '/secure/public/ct/remove-change-subscription-info', {
      data: {
        ...payload
      }
    })
  },
  /**
   * Adds phone number to billing and shipping address in cart
   */
  addPhoneNumberToAddress (cartID, phoneNumber) {
    return $axios.post(`${resource}/add-phone-number-to-address`, { phoneNumber, cartID })
  },
  addPhoneNumberAndEmailToAddress (cartID, phoneNumber, emailAddress) {
    return $axios.post(`${resource}/add-phone-number-to-address`, { phoneNumber, cartID, emailAddress })
  },
  addPrePaidEmail (cartID, emailAddress, cartItemGroupUpdate) {
    return $axios.get(`${resource}/add-prepaid-email/${cartID}/${cartItemGroupUpdate.groupID}/${cartItemGroupUpdate.sku}/${emailAddress}`)
  },

  addSavedAddressToCart (cartID, tempAddressIdentifier) {
    return $axios.post(`${resource}/add-saved-address`, { cartID, tempAddressIdentifier })
  }

})
